/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Key_Command_LabelInputs */



/**
* | output |
* | --- |
* | "Key Command" |
*
* @param {Shortcut_Keys_Key_Command_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_key_command_label = /** @type {((inputs?: Shortcut_Keys_Key_Command_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Key_Command_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commande")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tastenkombination")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comando chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ключевая команда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comando de teclado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按键命令")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キーコマンド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुख्य कमांड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comando de tecla")
	return /** @type {LocalizedString} */ ("Key Command")
});